import { create } from "zustand";
import { useFetchTourProgramApprovalSlice } from "../slices/TourProgramApprovalSlices/fetchTourProgramApprovalSlice";
import { useFetchTourDeviationApprovalSlice } from "../slices/TourProgramApprovalSlices/fetchTourDeviationApprovalSlice";
import { useAddTourProgramApprovalSlice } from "../slices/TourProgramApprovalSlices/addTourProgramApprovalSlice";
import { useAddTourDeviationApprovalSlice } from "../slices/TourProgramApprovalSlices/addTourDeviationApprovalSlice";

interface FetchTourProgramApprovalInterface
  extends ReturnType<typeof useFetchTourProgramApprovalSlice>,
  ReturnType<typeof useAddTourProgramApprovalSlice>,
  ReturnType<typeof useFetchTourDeviationApprovalSlice>,
  ReturnType<typeof useAddTourDeviationApprovalSlice>{}

export const TourProgramApprovalStore =
  create<FetchTourProgramApprovalInterface>((...a) => ({
    ...useFetchTourProgramApprovalSlice(...a),
    ...useAddTourProgramApprovalSlice(...a),
    ...useFetchTourDeviationApprovalSlice(...a),
    ...useAddTourDeviationApprovalSlice(...a),
  }));
